export enum Language {
  English = 'en',
  Norwegian = 'no',
  Swedish = 'sv',
}
